import React, { useState } from 'react';
import GridLayout, { WidthProvider } from 'react-grid-layout';
import { Page } from '@/components/page';
import { Toggle } from '@/components/toggle';
import { GridPanel } from '@/components/grid-panel';
import { ContainerListWidget } from '@/features/containers/components/container-list-widget';
import { ContainerDetailWidget } from '@/features/containers/components/container-detail-widget';
import { useTabId } from '@/hooks/use-tab-id';
import { useScreenId } from '@/hooks/use-screen-id';

const layout = [
  { i: 'list', x: 0, y: 0, w: 25, h: 25 },
  { i: 'detail', x: 25, y: 0, w: 15, h: 15 },
];

const AutoWidthGridLayout = WidthProvider(GridLayout);

export function ManageContainers() {
  const [isDraggable, setIsDraggable] = useState(false);
  const tabId = useTabId();
  const screenId = useScreenId();
  const idPrefix = `${tabId}/${screenId}`;

  if (!screenId || !tabId) {
    return null;
  }

  return (
    <Page
      title="Manage Containers"
      toolbar={
        <Toggle
          enabled={isDraggable}
          label="Enable drag"
          onChange={setIsDraggable}
        />
      }
    >
      <AutoWidthGridLayout
        className="layout"
        layout={layout}
        cols={40}
        rowHeight={30}
        isDraggable={isDraggable}
      >
        <GridPanel key="list">
          <ContainerListWidget id={`${idPrefix}/list`} />
        </GridPanel>
        <GridPanel key="detail">
          <ContainerDetailWidget id={`${idPrefix}/detail`} />
        </GridPanel>
      </AutoWidthGridLayout>
    </Page>
  );
}
